import React from "react";
import { Input, Button, Select, Form } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { hotelReviewSchema } from "../../schema/hotel.schema";

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 12 },
};

const HotelReviewForm = (props) => {
  const { hotelGetData, dataIndex, title, onSubmitData, isLoading, isUpdating } = props;

  const options = hotelGetData?.map((d) => (
    <Select.Option key={d._id}>
      {d.hotel_name} - ({d.hotel_code})
    </Select.Option>
  ));

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors,isSubmitted },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(hotelReviewSchema),
  });
  const watchHotelName = watch("_id");

  const handleSelectChange = (value)=>{
    setValue("_id",value);
    const result = hotelGetData?.find((e) => e._id === value);
    const config = {};
    config[dataIndex] = result[dataIndex];
    config["_id"] = value;
    setValue(dataIndex,result[dataIndex]);
  }
  
  return (
    <Form onFinish={handleSubmit(onSubmitData)} {...formItemLayout}>
      <Form.Item
        label="Hotel Name"
        required
        validateStatus={!watchHotelName && errors?._id ? "error" : ""}
        help={!watchHotelName && errors?._id?.message}
      >
        <Controller
          name="_id"
          control={control}
          render={({ field: { onChange, onBlur, value } }) => (
            <Select
              showSearch
              placeholder="Please Select Hotel"
              onChange={handleSelectChange}
              optionFilterProp="children"
              notFoundContent={null}
            >
              {options}
            </Select>
          )}
        />
      </Form.Item>
      <Form.Item label={title}>
        <Controller
          name={dataIndex}
          control={control}
          render={({ field: { onChange,value } }) => (
          <Input 
            value={value}
            onChange={onChange}          
          />)} />
      </Form.Item>
      <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
        <Button type="primary" htmlType="submit" loading={isUpdating}>
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};
export default HotelReviewForm;
